module.exports = __webpack_public_path__ + "img/settings.52e713fc.svg";